<div class="container"
  style="text-align: justify; background: transparent !important; margin-bottom: 18%; margin-top: -20px; height: 220px;">
  <div class="row row-class" align = "center" >
  <div class="col-12" >
    <h6 class="text-center" style="color: #6f706e !important; font-size: 20px;">Food Allergies/Intolerance</h6>
  <ng-container *ngFor="let allergies of user_details.userAllergens; index as i">
    <button class="buttonsallergy" [title]="allergies.allergens_name" [style.background-color]="'#ff0000'"
      [style.color]="'white'">
      <span>{{allergies.allergens_name}}</span> </button>&nbsp;&nbsp;
  </ng-container>
</div>
</div>
</div>
<style>
  @media only screen and (min-width: 600px) {
    .container {
      width: 424px;
      max-width: 100%;

    }

  }

  .container {
    position: relative;
    margin-left: auto;
    margin-right: auto;
    padding-right: 11px;
    padding-left: 11px;
    margin-top: -15px;
  }
  ::ng-deep.mat-bottom-sheet-container {
 
    min-width: 100vw;
    box-sizing: border-box;
    display: block;
    outline: 0;
    max-height: 30vh;
    overflow: auto;
  }

  .buttonsallergy {
    border-radius: 10px;
    height: auto;
    width: auto;
    background-color: white;
    color: black;
    width: 30%;
    border: none;
    margin-bottom: 5px;
    margin-top: 5px;
    padding: 2px;
    padding: 4px;
  }

  .buttonsgen {
    border-radius: 10px;
    height: auto;
    width: auto;
    background-color: white;
    color: black;
    border: none;
    width: 150px;
    padding: 2px;
    padding: 4px;
  }

  .buttonsdietary {
    border-radius: 10px;
    height: auto;
    width: auto;
    border: none;
    margin-top: 5px;
    margin-bottom: 5px;
    background-color: white;
    color: black;
    width: 30%;
    padding: 2px;
    padding: 4px;
  }
</style>